import React, { useState } from "react";
import adminStyles from "../../styles/AdminProdutos.module.css";

interface ProdutoListProps {
  produtos: any[];
  handleEdit: (produto: any) => void;
  handleDelete: (id: number) => void;
  publicoLabels: Record<string, string>;
  baseUrl: string;
}

const ProdutoList: React.FC<ProdutoListProps> = ({
  produtos,
  handleEdit,
  handleDelete,
  publicoLabels,
  baseUrl
}) => {
  const [expandedIds, setExpandedIds] = useState<Set<number>>(new Set());

  const toggleExpand = (id: number) => {
    const newSet = new Set(expandedIds);
    if (newSet.has(id)) {
      newSet.delete(id);
    } else {
      newSet.add(id);
    }
    setExpandedIds(newSet);
  };

  return (
    <div className={adminStyles.list}>
      {produtos.map((produto) => {
        const isExpanded = expandedIds.has(produto.id);

        return (
          <div key={produto.id} className={adminStyles.card}>
            {/* Cabeçalho clicável */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer"
              }}
              onClick={() => toggleExpand(produto.id)}
            >
              <strong>{produto.titulo}</strong>
              <span style={{ fontSize: "18px" }}>{isExpanded ? "▲" : "▼"}</span>
            </div>

            {/* Conteúdo do card */}
            {isExpanded && (
              <div className={adminStyles.cardContent}>
                <div>Serviço: {produto.servicoNome}</div>
                <div>Preço: R${produto.precoBase.toFixed(2)}</div>
                <div>Duração: {produto.duracaoEmMinutos ?? "-" } min</div>
                <div>Idiomas: {produto.idiomas?.join(", ") || "-"}</div>
                <div>Idade mínima: {produto.idadeMinima ?? "-"}</div>
                <div>Público: {produto.publicoAlvo ? publicoLabels[produto.publicoAlvo] : "-"}</div>
                <div className={adminStyles.fotosContainer}>
                  {produto.fotoUrls?.map((url: string, idx: number) => (
                    <img
                      key={idx}
                      src={`${baseUrl}${url}`}
                      alt="Foto do produto"
                      className={adminStyles.fotoList}
                    />
                  ))}
                </div>
                <div className={adminStyles.cardButtons}>
                  <button onClick={() => handleEdit(produto)}>✏️ Editar</button>
                  <button onClick={() => handleDelete(produto.id)}>🗑️ Deletar</button>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ProdutoList;